/* ALVA cart upsell: swap ALVA Air -> ALVA Sense with an exclusive discount code.
   Delegated listeners so it keeps working when the cart drawer/page re-renders. */
(function () {
  if (window.__alvaCartUpsell) return;
  window.__alvaCartUpsell = true;

  // Market-aware root ("/", "/es/", "/en-gb/" ...) so the cart keeps the visitor's language and currency
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-alva-up-variant]');
    if (pill) {
      var box = pill.closest('[data-alva-up]');
      if (!box) return;
      box.querySelectorAll('[data-alva-up-variant]').forEach(function (p) { p.classList.toggle('is-on', p === pill); });
      box.setAttribute('data-variant', pill.getAttribute('data-alva-up-variant'));
      return;
    }

    var btn = e.target.closest('[data-alva-swap]');
    if (!btn) return;
    var root = btn.closest('[data-alva-up]');
    if (!root) return;

    var key = root.getAttribute('data-air-key');
    var qty = parseInt(root.getAttribute('data-qty'), 10) || 1;
    var variant = parseInt(root.getAttribute('data-variant'), 10);
    var code = root.getAttribute('data-code');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = root.getAttribute('data-busy') || '…';

    // add Sense first so a failure never leaves the shopper with an empty cart
    json(ROOT + 'cart/add.js', { items: [{ id: variant, quantity: qty }] })
      .then(function () { return json(ROOT + 'cart/change.js', { id: key, quantity: 0 }); })
      .then(function () {
        try { sessionStorage.setItem('alvaUpsellApplied', '1'); } catch (err) {}
        window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart');
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        var note = root.querySelector('.alva-up__note');
        if (note) note.textContent = root.getAttribute('data-error') || '';
      });
  });

  function showOk() {
    var ok = document.querySelector('[data-alva-up-ok]');
    if (!ok) return;
    try {
      if (sessionStorage.getItem('alvaUpsellApplied') === '1') ok.hidden = false;
    } catch (err) {}
  }
  document.addEventListener('DOMContentLoaded', showOk);
})();
